import { withStyles } from '@material-ui/core/styles';
import InputBase from '@material-ui/core/InputBase';

export const TextInput = withStyles(theme => ({
  root: {
    'label + &': {
      marginTop: theme.spacing(3),
    },
  },
  error: {
    '& .MuiInputBase-input': {
      border: `2px solid ${theme.palette.error.main}`,
    },
  },
  input: {
    width: '100%',
    borderRadius: 4,
    position: 'relative',
    marginTop: '0.5rem',
    backgroundColor: theme.palette.common.white,
    border: `2px solid ${theme.palette.common.silver}`,
    fontSize: 14,
    padding: '10px 12px',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    '&:focus': {
      borderColor: theme.palette.primary.main,
    },
  },
}))(InputBase);
